import { useSelector, useDispatch } from 'react-redux'
import { Customer, CustomerAddress } from 'lib/types'
import { unsetSession } from 'lib/core/data/auth/session'
import { getIsLoggedIn } from 'lib/core/data/auth/session/selectors'
import { me } from 'lib/core/data/customer/me'
import {
  getMe,
  getDefaultBillingAddress,
  getDefaultShippingAddress,
  getSlice,
  CustomerProcessors, getIsSessionEndedDueInvalidToken
} from 'lib/core/data/customer/me/selectors'
import { useCoreContext } from '../useCoreContext'

interface UseCustomer {
  addresses: CustomerAddress[]
  customer: Customer | undefined
  defaultBillingAddress: CustomerAddress | undefined
  defaultShippingAddress: CustomerAddress | undefined
  fetchCustomer: () => void
  logout: () => void
  isFetching: boolean
  isLoggedIn: boolean
  isSessionDefined: boolean
  isSessionEndedDueInvalidToken: boolean
}

export const useCustomer = (): UseCustomer => {
  const dispatch = useDispatch()
  const { data } = useCoreContext()
  const processors: CustomerProcessors = {
    customerProcessor: data?.customer?.processor,
    customerAddressProcessor: data?.customerAddress?.processor
  }

  const isLoggedIn = useSelector(getIsLoggedIn)
  const customer = useSelector(getMe(processors))
  const defaultBillingAddress = useSelector(getDefaultBillingAddress(processors))
  const defaultShippingAddress = useSelector(getDefaultShippingAddress(processors))
  const { isFetching } = useSelector(getSlice)
  const isSessionEndedDueInvalidToken = useSelector(getIsSessionEndedDueInvalidToken)

  return {
    addresses: customer?.addresses ?? [],
    customer: isLoggedIn && customer ? customer : undefined,
    defaultBillingAddress,
    defaultShippingAddress,
    fetchCustomer: () => {
      dispatch(me())
    },
    logout: () => {
      dispatch(unsetSession())
    },
    isFetching,
    isLoggedIn,
    isSessionDefined: isLoggedIn !== null,
    isSessionEndedDueInvalidToken
  }
}
